<!--
 * @Descripttion:展示商品列表组件 
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-05 15:44:31
--> 

<template>
  <div id="myList" class="myList">
    <ul>
      <li v-for="(item,index) in list" :key="item.id">
        <el-popover placement="top">
          <p>Are you sure you want to delete?</p>
          <div style="text-align: right; margin: 10px 0 0">
            <el-button type="primary" size="mini" @click="deleteFavorite(item.id,index)">Confirm</el-button>
          </div>
          <i class="el-icon-close delete" slot="reference" v-show="isDelete"></i>
        </el-popover>
        <router-link :to="{ path: '/goods/details', query: {productID:item.id} }">
          <img :src="item.img_path" alt />
          <h2>{{item.name}}</h2>
          <h3>{{item.title}}</h3>
          <p>
            <span>{{item.discount_price}} ₹</span>
            <span v-show="item.price != item.discount_price" class="del">{{item.price}}₹</span>
          </p>
        </router-link>
      </li>
      <li v-show="isMore && list.length>=1" id="more">
        <router-link :to="{ path: '/goods', query: {categoryID:categoryID} }">
          More
          <i class="el-icon-d-arrow-right"></i>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import * as favoriteAPI from '@/api/favorites'
export default {
  name: 'MyList',
  // list为父组件传过来的商品列表
  // isMore为是否显示“浏览更多”
  props: ['list', 'isMore', 'isDelete'],
  data() {
    return {}
  },
  computed: {
    // 通过list获取当前显示的商品的分类ID，用于“浏览更多”链接的参数
    categoryID: function() {
      let categoryID = []
      if (this.list != '') {
        for (let i = 0; i < this.list.length; i++) {
          const id = this.list[i].category_id
          if (!categoryID.includes(id)) {
            categoryID.push(id)
          }
        }
      }
      return categoryID
    }
  },
  methods: {
    deleteFavorite(product_id, index) {
      var form = {
        user_id: this.$store.getters.getUser.id,
        product_id: product_id
      }
      favoriteAPI
        .deleteFavorite(form)
        .then(res => {
          if (res.status === 200) {
            this.list.splice(index, 1)
            this.notifySucceed('Success')
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    }
  }
}
</script>
<style scoped>
.myList ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}
.myList ul li {
  z-index: 1;
  width: 100%;
  min-height: 440px;
  padding: 14px;
  margin: 0;
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #efeaf3;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  position: relative;
}
.myList ul li a {
  display: block;
  color: inherit;
}
.myList ul li:hover {
  z-index: 2;
  -webkit-box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  -webkit-transform: translate3d(0, -2px, 0);
  transform: translate3d(0, -2px, 0);
}
.myList ul li img {
  display: block;
  width: 100%;
  height: 330px;
  background: url(../assets/imgs/placeholder.png) no-repeat 50%;
  border-radius: 8px;
  object-fit: cover;
}
.myList ul li h2 {
  margin: 12px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: #285B3A;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.myList ul li h3 {
  margin: 6px 0 0;
  height: 18px;
  font-size: 11px;
  font-weight: 400;
  color: #8a7f97;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.myList ul li p {
  margin: 10px 0 0;
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  color: #ff5f8f;
  font-weight: 600;
}
.myList ul li p .del {
  color: #b9afc5;
  text-decoration: line-through;
}
.myList #more {
  min-height: 440px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d7cfdf;
  border-radius: 10px;
}

@media (max-width: 900px) {
  .myList ul {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .myList ul li {
    min-height: 360px;
    padding: 12px;
  }
  .myList ul li img {
    height: 260px;
  }
  .myList #more {
    min-height: 360px;
  }
}
.myList #more a {
  font-size: 14px;
  color: #5a4b6c;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.myList #more a:hover {
  color: #ff5f8f;
}
.myList ul li .delete {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}
.myList ul li:hover .delete {
  display: block;
}
.myList ul li .delete:hover {
  color: #3E8E5A;
}
</style>
